import { useController } from "react-hook-form";
import { Autocomplete, TextField } from "@mui/material";

export function MiControlledAutoComplete({
  name = "",
  formControl: control = {},
  rules,
  options,
  getOptionLabel,
  label,
  required,
  value,
  textFieldOnChange,
  textFieldOnFocus,
  disabled,
  readOnly,
  textFieldProps,
  maxLength,
  placeholder,
  onInputChange,
  ...props
}) {
  const {
    field: { onChange, onBlur, value: defaultValue, ref },
    fieldState: { error },
  } = useController({ name, control, rules });

  return (
    <Autocomplete
      {...props}
      data-testid={`mi-autocomplete-${name}`}
      options={options}
      getOptionLabel={getOptionLabel}
      inputValue={value || defaultValue || ""}
      onInputChange={(_, value) => {
        (onInputChange || onChange)(value);
      }}
      onBlur={onBlur}
      size="small"
      fullWidth
      openOnFocus
      readOnly={readOnly}
      disabled={disabled}
      renderInput={({ inputProps, ...params }) => (
        <TextField
          {...params}
          {...textFieldProps}
          required={required}
          label={label}
          inputRef={ref}
          error={!!error && !readOnly}
          onChange={textFieldOnChange}
          placeholder={placeholder || label}
          helperText={error && !readOnly ? error.message : ""}
          inputProps={{
            readOnly,
            "data-testid": `mi-autocomplete-input-${name}`,
            ...inputProps,
            maxLength,
          }}
          onFocus={textFieldOnFocus}
        />
      )}
    />
  );
}
